import { Suspense, useMemo } from "react";
import { RouterProvider as ReactRouterProvider, createBrowserRouter } from "react-router-dom";

import type { FC, ReactNode } from "react";
import type { RouteObject } from "react-router-dom";

const DEFAULT_SUSPENSE_FALLBACK = null;
type CreateBrowserRouterOptions = Parameters<typeof createBrowserRouter>[1];
type Router = ReturnType<typeof createBrowserRouter>;

export interface RouterProviderProps {
    routes: RouteObject[];
    router?: Router;
    fallbackElement?: ReactNode;
    suspenseFallback?: ReactNode;
    createRouterOptions?: CreateBrowserRouterOptions;
}

export const RouterProvider: FC<RouterProviderProps> = ({
    routes,
    router,
    fallbackElement,
    suspenseFallback = DEFAULT_SUSPENSE_FALLBACK,
    createRouterOptions,
}) => {
    const resolvedRouter = useMemo(() => {
        if (router) {
            return router;
        }

        return createBrowserRouter(routes, createRouterOptions);
    }, [router, routes, createRouterOptions]);

    const provider = <ReactRouterProvider router={resolvedRouter} fallbackElement={fallbackElement ?? undefined} />;

    if (suspenseFallback === DEFAULT_SUSPENSE_FALLBACK) {
        return provider;
    }

    return <Suspense fallback={suspenseFallback}>{provider}</Suspense>;
};
